import { HStack } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { useState } from 'react'

import { questionActionAtom } from '@/store/translate'

import Star from './Star'

const Container = ({ values, onRatingClick }: { values: Array<string>; onRatingClick: ((value: string) => void) | undefined }) => {
    const [, setQuestionAction] = useAtom(questionActionAtom)
    const [state, setState] = useState<{ hoveredIndex: number | null; selected: string | null }>({
        hoveredIndex: null,
        selected: null,
    })

    const handleMouseEnter = (id: number | null) => {
        setState((prevState) => ({ ...prevState, hoveredIndex: id }))
    }

    const handleMouseLeave = () => {
        setState((prevState) => ({ ...prevState, hoveredIndex: null }))
    }

    const handleClick = (id: string | null) => {
        setState({ hoveredIndex: null, selected: id })
        if (id && onRatingClick) {
            setQuestionAction('QCallToAction')
            onRatingClick(id)
        }
    }

    return (
        <HStack gap={2}>
            {values.map((id, index) => {
                const isFilled = () => {
                    if (state.hoveredIndex !== null) {
                        return index <= state.hoveredIndex
                    }
                    if (state.selected !== null) {
                        return index <= parseInt(state.selected, 10)
                    }
                    return false
                }

                return (
                    <Star
                        key={id + index}
                        id={id}
                        filled={isFilled()}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => handleClick(id)}
                    />
                )
            })}
        </HStack>
    )
}

export default Container
